import { Pipe, PipeTransform } from '@angular/core';

import { BigDecimalService } from '../../core/services/big-decimal.service';

@Pipe({
  name: 'number'
})
export class NumberPipe implements PipeTransform {
  constructor (
    private bigDecimalService: BigDecimalService
  ) {}

  transform ( value : string, scale = 2 ) : number {
    const num = this.bigDecimalService.get(value, scale).toString();

    return +num;
  }
}